<div id="floating-button-requisition" fxLayout="column" fxLayoutAlign="start center">
  <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
    <div fxLayout="row" fxLayoutAlign="stretch" class="padding-block">
      <h3>Search Requisitions</h3>
    </div>
    <form [formGroup]="requisitionSearchForm" (ngSubmit)="searchRequisitions()">
      <div class="padding-block" fxLayout="row" fxLayoutAlign="space-between stretch">
        <div fxLayout="column" [ngStyle.xs]="{width: '100%'}" [ngStyle.sm]="{width: '60%'}">
          <app-from-to-date-range-selector
            [startGroupControl]="convertToFormControl(requisitionSearchForm.get('startDate'))"
            [endGroupControl]="convertToFormControl(requisitionSearchForm.get('endDate'))">
          </app-from-to-date-range-selector>
        </div>
        <app-client-selector fxShow fxHide.lt-md [ngStyle.md]="{width: '50%', 'padding-left': '20px' }"
          *ngIf="role !== 'Physician' && role !== 'Patient'" [clearBtn]="false" id="clientSelector"
                             [control]="requisitionSearchForm.get('client')"></app-client-selector>

          <app-selector
              fxShow fxHide.lt-md [ngStyle.md]="{'padding-left': '20px' }" *ngIf="role !== 'Physician' && role !== 'Patient'"
              [items]="unitDataSource.value"
              [label]="'Unit'"
              [remoteOperations]="true"
              [control]="requisitionSearchForm.get('unit')"
              [displayExpr]="'name'"
              [keyExpr]="'id'">
          </app-selector>

        <app-patient-selector fxShow fxHide.lt-md [ngStyle.md]="{'padding-left': '20px' }" *ngIf="role !== 'Patient'"
          [control]="requisitionSearchForm.get('patient')"></app-patient-selector>

        <div fxShow fxHide.lt-sm fxHide.gt-sm fxLayout="row" fxLayoutAlign="end end" style="padding-left: 30px; padding-bottom: 5px">
          <app-search-btn style="margin-right: 10px" [disabled]="!requisitionSearchForm.valid" (click)="searchRequisitions()"></app-search-btn>
          <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
        </div>
      </div>
      <div fxShow fxHide.sm class="padding-block" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="end center">
        <div fxLayout="row" fxLayoutAlign="start" style="width: 500px" fxShow fxHide.lt-md>
          <app-requisition-status-radio-buttons [control]="convertToFormControl(requisitionSearchForm.get('status'))"></app-requisition-status-radio-buttons>
          <app-electronic-signature-radio-button style="margin-left: 16px" [control]="convertToFormControl(requisitionSearchForm.get('signature'))"></app-electronic-signature-radio-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end">
          <app-search-btn style="margin-right: 5px" [disabled]="!requisitionSearchForm.valid" (click)="searchRequisitions()"></app-search-btn>
          <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
        </div>
      </div>
    </form>
  </div>
  <app-requisition-search-content [filtersSubmitted]="formSubmitted"></app-requisition-search-content>
</div>

